"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
class CreativeFormatNetwork {
    constructor({ id, key, name }) {
        this.toJSON = () => ({
            id: this.id,
            key: this.key,
            name: this.name,
        });
        this.id = id;
        this.key = key;
        this.name = name;
    }
}
CreativeFormatNetwork.fromJSON = (json) => {
    const { id, key, name } = Object.assign({}, json);
    if (typeof id !== 'string')
        throw new Error('.id must be a string');
    if (typeof key !== 'string')
        throw new Error('.key must be a string');
    if (typeof name !== 'string')
        throw new Error('.name must be a string');
    switch (key) {
        case 'facebook':
        case 'instagram':
        case 'snapchat':
        case 'youtube':
        case 'twitter':
        case 'line':
        case 'yahoo':
        case 'google':
        case 'apple':
        case 'amazon':
        case 'owned_media':
        case 'other':
        case 'any_network':
            // OK
            break;
        default:
            throw new Error(`A creative network key "${key}" is not valid.`);
    }
    return new CreativeFormatNetwork({ id, key, name });
};
exports.default = CreativeFormatNetwork;
